import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleQuote12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSpeechBubbleQuote12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.429 10V9H1.5a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H6.613l-.286.26-1.898 1.728zm6.071 0H7l-1.898 1.727a1 1 0 0 1-1.673-.74V10H1.5A1.5 1.5 0 0 1 0 8.5v-6A1.5 1.5 0 0 1 1.5 1h9A1.5 1.5 0 0 1 12 2.5v6a1.5 1.5 0 0 1-1.5 1.5M5.179 4.98l.01-.003a.5.5 0 0 0-.295-.955l.142.468-.143-.468H4.89l-.004.002-.012.004a1 1 0 0 0-.146.056c-.09.039-.21.098-.34.183a1.9 1.9 0 0 0-.755.91c-.16.427-.148.844-.105 1.137q.028.182.063.307a.96.96 0 1 0 .998-1.138.9.9 0 0 1 .344-.378 1.3 1.3 0 0 1 .246-.124m3 0 .01-.003a.5.5 0 0 0-.295-.955l.142.468-.143-.468H7.89l-.004.002-.012.004a1 1 0 0 0-.146.056c-.09.039-.21.098-.34.183a1.9 1.9 0 0 0-.755.91c-.16.427-.148.844-.105 1.137q.028.182.063.307a.96.96 0 1 0 .998-1.138.9.9 0 0 1 .344-.378 1.3 1.3 0 0 1 .246-.124"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeechBubbleQuote12);
